import { showSuccessToast } from '@/utils/toasts/Toasts';

/**
 * Copies text to clipboard and shows a success toast
 * @param text The text to copy to clipboard
 * @param message Optional custom success message; defaults to "Copied!"
 * @returns Promise that resolves when the text is copied
 */
export const copyToClipboard = async (text: string, message: string = 'Copied!'): Promise<void> => {
  try {
    await navigator.clipboard.writeText(text);
    showSuccessToast(message, 'bg-[#292829]');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to copy text: ', err);
  }
};
